import React from 'react'
import CookiesComp from '../Components/cookiessection/CookiesComp'

function Cookies() {
  return (
    <>
    <CookiesComp />
    </>
  )
}

export default Cookies